export default __webpack_public_path__ + "static/media/ic_french_polynesia.8ae40aec.svg";